export enum CompaniesSortField {
  LegalName = 'legalname',
  TradingName = 'tradingname',
  Sector = 'sector',
  Size = 'size',
  Type = 'type',
  CreatedAt = 'createdat'
}
